// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"121":"42254ca7d7da1462c17a","224":"117cb29d00740ff59531","534":"01563f40501579486abb"}[chunkId] + ".js";
};